module.exports = __webpack_public_path__ + "static/media/3.1b7548aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/remoteSmartLinkIOT/img/3.png
// module id = 466
// module chunks = 0